import { Delete, Edit, MenuOpen } from '@mui/icons-material'
import { IconButton, useTheme } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'

import AuditIconButton from '../../../../base/components/Auditoria/AuditIconButton'
import SimpleMenu, { SimpleMenuItem } from '../../../../base/components/MyMenu/SimpleMenu'
import { genPath } from '../../../../utils/genPath'
import { notSuccess } from '../../../../utils/notification'
import { swalClose, swalException, swalLoading } from '../../../../utils/swal'
import { apiRecetaEliminar } from '../../api/apiRecetasEliminar'
import { RecetaProp } from '../../interfaces'
import { recetasRoutesMap } from '../../recetasRoutes'

interface RecetaRowActionsProps {
  row: RecetaProp
  refetch: () => void
}

const RecetaMenu: FunctionComponent<RecetaRowActionsProps> = ({ row, refetch }) => {
  const theme = useTheme()
  const confirm = useConfirm()

  // Eliminación de la Receta
  const eliminarReceta = async (row: RecetaProp) => {
    try {
      const { confirmed } = await confirm({
        content: (
          <>
            Confirma que desea eliminar el articulo <strong>{row.nombreReceta}</strong>
          </>
        ),
      })
      if (!confirmed) return

      swalLoading()
      const resp = await apiRecetaEliminar(row._id)
      if (resp) {
        notSuccess()
        refetch()
      }
    } catch (error) {
      swalException(error)
    } finally {
      swalClose()
    }
  }
  return (
    <>
      <SimpleMenu
        menuButton={
          <IconButton aria-label="menuGestionRecetas">
            <MenuOpen />
          </IconButton>
        }
      >
        {/* <SimpleMenuItem
          onClick={() => {
            navigate(genPath(recetasRoutesMap.actualizar.path, { id: row._id }))            
          }}
        >
          <Edit /> Editar
        </SimpleMenuItem> */}
        <SimpleMenuItem
          color={theme.palette.error.main}
          sx={{ color: theme.palette.error.main }}
          onClick={() => eliminarReceta(row)}
        >
          <Delete />
          Eliminar
        </SimpleMenuItem>
      </SimpleMenu>
      <IconButton
        component={Link}
        to={genPath(recetasRoutesMap.actualizar.path, { id: row._id })}
        sx={{ color: theme.palette.primary.main }}
        size={'small'}
      >
        <Edit />
      </IconButton>
      {/* <IconButton
        onClick={() => eliminarReceta(row)}
        sx={{ color: theme.palette.error.main, p: 0.7 }}
      >
        <Delete />
      </IconButton> */}
      <AuditIconButton row={row} />
    </>
  )
}

export default RecetaMenu
